export function formatDuration(duration: number): { time: number; unit: string } {
  if (duration < 60) {
    return { time: duration, unit: "sec" }
  } else if (duration < 3600) {
    return { time: Math.round(duration / 60), unit: "min" }
  } else {
    const diffHours = Math.round(duration / 3600)
    return { time: diffHours, unit: diffHours === 1 ? " hour" : " hours" }
  }
}
